package fr.frux.feature.site.detail

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.WarningAmber
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.feature.site.labelRes
import fr.frux.feature.site.resources.Res
import fr.frux.feature.site.resources.site_lookalike
import fr.frux.shared.domain.model.SitePlanting
import fr.frux.shared.domain.model.SpeciesLookalike
import org.jetbrains.compose.resources.stringResource

/** Étiquette du nom d'espèce d'une plantation, pour vérifier l'ordre des lignes. */
internal const val PLANTING_ROW_TAG = "site_planting_name"

/** Une plantation estimée : espèce, tranche d'effectif, note libre, puis ses sosies dangereux. */
@Composable
fun PlantingRow(
    planting: SitePlanting,
    lookalikes: List<SpeciesLookalike>,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier.fillMaxWidth().padding(vertical = FruxSpacing.sm),
        verticalArrangement = Arrangement.spacedBy(2.dp),
    ) {
        Text(
            text = planting.species.commonNameFr,
            style = MaterialTheme.typography.titleSmall,
            modifier = Modifier.testTag(PLANTING_ROW_TAG),
        )
        Text(
            text = stringResource(planting.count.labelRes()),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        planting.note?.takeIf { it.isNotBlank() }?.let { note ->
            Text(
                text = note,
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        lookalikes.forEach { lookalike -> LookalikeLine(lookalike) }
    }
}

@Composable
private fun LookalikeLine(lookalike: SpeciesLookalike) {
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(FruxSpacing.xs)) {
        Icon(
            imageVector = Icons.Outlined.WarningAmber,
            contentDescription = null,
            tint = MaterialTheme.colorScheme.error,
            modifier = Modifier.size(16.dp),
        )
        Text(
            text = stringResource(Res.string.site_lookalike, lookalike.commonNameFr, lookalike.distinguishingNote),
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.error,
        )
    }
}
